import { render, staticRenderFns } from "./BaladyAnalytics.vue?vue&type=template&id=05e277dc&scoped=true"
import script from "./BaladyAnalytics.vue?vue&type=script&lang=js"
export * from "./BaladyAnalytics.vue?vue&type=script&lang=js"
import style0 from "./BaladyAnalytics.vue?vue&type=style&index=0&id=05e277dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e277dc",
  null
  
)

export default component.exports